import { useNavigate } from "react-router-dom";
import { routes as mobileRoutes } from "../router/mobile/routes";
import { routes as webRoutes } from "../router/web/routes";
import { routes as publicRoutes } from "../router/public/routes";

// Utility function to manually clear all navigation blockers
export const clearNavigationBlockers = () => {
  (window as any).navigationBlocker = null;
  (window as any).hasUnsavedChanges = false;
  (window as any).navigationBlockerPath = null;
};

// Simple, safe navigation hook
export const useAppNavigate = () => {
  const navigate = useNavigate();

  return navigate;
};

export { useNavigate };

export type TMobileRouterPath =
  (typeof mobileRoutes)[keyof typeof mobileRoutes]["path"];
export type TWebRouterPath = (typeof webRoutes)[keyof typeof webRoutes]["path"];
export type TPublicRouterPath =
  (typeof publicRoutes)[keyof typeof publicRoutes]["path"];
